<!--大項目管理-->

<template>
  <div class="tab-container">
    <div class="help-header">
      <h1>こんにちは<br>何かお困りですか？</h1>
      <!-- <input v-if="isAgent" type="checkbox" id="demo01" checked /> -->
      <input type="checkbox" id="demo01" checked />
      <label for="demo01" data-on-label="isAgent" data-off-label="Off" @click="isAgentButton=!isAgentButton"></label>
    </div>
    <div class="flex content-container-helpItem">
      <div class="columns is-multiline is-mobile" style="justify-content: center;">
        <!-- <span v-if="isAgentButton && isAgent"> -->
        <span v-if="isAgentButton">
          <div class="help-card" style="margin: 10px;">
            <router-link to="../help/input/">
              <div
                class="card-item-agent"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <h2>項目編集</h2>
              </div>
              <div
                class="card-contents"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <figure class="img-icon">
                  <img src="../../assets/template/close.svg" style="transform: rotate(-45deg);">
                </figure>
              </div>
              <div
                class="card-description"
                style="display: flex; justify-content: center; align-items: center; margin:20px;"
              >
                <h3>項目を追加、編集する場合は<br>こちらをクリック</h3>
              </div>
            </router-link>
          </div>
        </span>
        <span
          v-for="(helpItem, index) in sortedHelpItemsBySort"
          :key="index"
          @mouseover="cbStatusHover=helpItem"
        >
          <div class="help-card" style="margin: 10px;" @click="routerClick(helpItem.item_id)">
            <router-link to="../help/category/">
              <div
                class="card-item"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <h2>{{ helpItem.item }}</h2>
              </div>
              <div
                class="card-contents"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <figure class="img-icon">
                  <img :src="helpItem.image" v-if="helpItem.image!=''">
                  <img src="../../assets/template/human.png" v-if="helpItem.image==''">
                </figure>
              </div>
              <div
                class="card-description"
                style="display: flex; justify-content: center; align-items: center; margin:20px;"
              >
                <h3>{{helpItem.description}}</h3>
              </div>
            </router-link>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "HelpBody",
  componentName: "HelpBody",
  computed: {
    ...mapState("help", ["helpItems", "helpImages", "active"]),
    ...mapState("auth", ["user"]),
    sortedHelpItemsBySort() {
      console.debug('*** Start *** sortedHelpItemsBySort')
      return this.helpItems.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    }
  },
  data() {
    return {
     isAgentButton:true, 
    };
  },
  mounted() {
    console.debug('*** Start *** mounted')
    this.$store.dispatch("help/getHelpItem");
    this.$store.dispatch("help/getHelpImage");
    console.debug('*** End *** mounted')
  },
  methods:{
    routerClick(id){
      this.$store.dispatch("help/setActive",{ active:id });
    }
  },
};
</script>

<style scoped>
h1 {
  font-weight: 700;
  font-size: 40px;
  text-align: center;
}
h2 {
  font-weight: 700;
  font-size: 26px;
}
h3 {
  font-weight: 400;
  font-size: 20px;
}
.tab-container {
  margin: 0;
  height: calc(100vh);
  width: calc(100%);
  background: #f2f2f2;
}
.flex {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.content-container-helpItem {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 50px;
  width: 90%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100vh;
  padding-bottom: 220px;
  margin: 0px auto;
}
.help-card {
  border-radius: 5px;
  max-width: 400px;
  min-width: 400px;
  max-height: 380px;
  min-height: 380px;
  cursor: pointer;
  border:solid 3px #d3d1d1;
}
.help-card:hover {
  background: #d3d1d1;
  transform: scale(1.1);
  transition: 0.2s;
}
.setting-card-description {
  display: flex;
  justify-content: center;
  align-items: center;
}
.help-header {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  color: white;
  background: #AA0066;
}
.card-header {
  height: 95px;
  padding: 7%;
}
.img-icon > img {
  display: block;
  min-width: 128px;
  min-height: 128px;
  width: 128px;
  height: 128px;
  max-width: 128px;
  max-height: 128px;
  border-radius: 50%;
}
.card-contents {
  padding: 0 0 0 0;
}
.card-item {
  min-height: 120px;
  max-height: 120px;
  padding: 20px;
}
.card-item-agent {
  min-height: 120px;
  max-height: 120px;
  padding: 20px;
  color:RED;
}
a:link {
  color: #000000;
}
a:visited {
  color: #000000;
}
a:hover {
  color: #000000;
}
a:active {
  color: #000000;
}
input {
  display: none;
}
input+label,
input+label::before,
input+label::after {
  -webkit-transition: all .2s;
  transition: all .2s;
}
input+label {
  display: inline-block;
  position: relative;
  width: 120px;
  height: 48px;
  border-radius: 24px;
  cursor: pointer;
}
input+label::before {
  display: block;
  content: attr(data-off-label);
  position: absolute;
  top: 12px;
  right: 7px;
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 18px;
}
input+label::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 44px;
  height: 44px;
  background-color: #fff;
  border-radius: 50%;
}
input:checked+label::before {
  content: attr(data-on-label);
  left: 7px;
  right: auto;
  color: #fff;
}
input:checked+label::after {
  left: 74px;
  background-color: #f7f7f7;
}
#demo01+label {
  background-color: #eee;
}
#demo01+label::before {
  color: #aaa;
}
#demo01:checked+label {
  background-color: #3498db;
}
#demo01:checked+label::before {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Help/HelpBody.vue